<div class="login-container">
    <header>
        <img class="stc-logo" src="assets/images/STC_logo.svg" alt="Login image" />
    </header>

    <div class="login-wrapper loginBox">
        <div class="login-form-container" [ngClass]="{ error: errorFlagServiceFailure }">
            <label class="login-text">{{ 'logedIn' | translate }} </label>
            <div class="alert alert-danger" *ngIf="errorFlagServiceFailure">
                <div class="d-flex align-items-center">
                    <span class="stc-font-danger"> {{ errorMessage | translate }} </span>
                </div>
            </div>

            <form [formGroup]="newRequestForm">
                <div class="controls">
                    <div ngbDropdown #domainsListMenu="ngbDropdown" class="w-100">
                        <div class="login-input" NgbDropdownAnchor>
                            <span class="material-symbols-outlined"> person</span>

                            <!-- Email Input -->
                            <input
                                #email
                                autocomplete="__away"
                                class="form-control"
                                type="text"
                                name="email"
                                open="true"
                                (click)="domainsListMenu.close()"
                                [placeholder]="'emailV2' | translate"
                                (keyup)="showDomains($event)"
                                [readonly]="domainsListMenu.isOpen() ? true : false"
                                formControlName="{{ emailFormControl }}"
                                [(ngModel)]="userEmail"
                            />
                            <span class="material-symbols-outlined">help</span>
                        </div>

                        <mat-hint
                            class="hint-as-error"
                            *ngIf="
                                newRequestForm.get(emailFormControl).hasError('invalidEmail') && !newRequestForm.get(emailFormControl).hasError('whitespace')
                            "
                        >
                            {{ 'emailErrorMessage' | translate }}
                        </mat-hint>

                        <mat-hint class="hint-as-error" *ngIf="newRequestForm.get(emailFormControl).hasError('whitespace')">
                            {{ 'emailWhiteSpaceErrorMessage' | translate }}
                        </mat-hint>

                        <div ngbDropdownMenu>
                            <button class="dontRemove"></button>
                            <button
                                *ngFor="let domain of domainList"
                                (click)="getDomainName($event)"
                                (keydown.enter)="getDomainName($event)"
                                [attr.emailData]="domain.domainValue"
                                ngbDropdownItem
                            >
                                {{ domain.domainName }}
                            </button>
                        </div>
                    </div>
                    <div>
                        <div class="login-input">
                            <span class="material-symbols-outlined"> lock</span>
                            <!-- Password Input -->
                            <input #password [type]="passFiledType" placeholder="{{ 'password' | translate }}" formControlName="{{ passwordFormControl }}" />
                            <span
                                class="fa fa-eye"
                                [class.d-none]="!password.value"
                                [class.fa-eye-slash]="passwordEyeFlag === 1"
                                (click)="changPassType()"
                            ></span>
                        </div>
                        <mat-hint
                            class="hint-as-error"
                            *ngIf="newRequestForm.get(passwordFormControl).hasError('whitespace') && newRequestForm.get(passwordFormControl).touched"
                        >
                            {{ 'passwordWhiteSpaceErrorMessage' | translate }}
                        </mat-hint>
                    </div>
                    <div class="reset-password-wrappper">
                        <span class="fa fa-key"></span>
                        <input type="reset" value="{{ 'replaceChangePassword' | translate }}" />
                    </div>
                    <div class="submit-btn-wrapper">
                        <button
                            class="btn btn-login"
                            type="submit"
                            [disabled]="newRequestForm.status === 'INVALID'"
                            (click)="login(email.value, password.value)"
                        >
                            {{ 'logIn' | translate }}
                            <span class="material-symbols-outlined arrow-icon"> arrow_back </span>
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div class="login-image-container">
            <img class="login-image" src="assets/images/login-image.png" alt="login image" />
        </div>
    </div>
</div>
